import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput, Button, Table, DataTable, TableContainer, TableHead, TableHeader, TableBody, TableRow,
    ComposedModal, ModalHeader, ModalBody, ModalFooter, DataTableSkeleton
} from 'carbon-components-react';
import { RadioButton20, RadioButtonChecked20 } from '@carbon/icons-react';
import { showNotification } from '../helpers/notification/BaseNotification';
import { getSuccess, getError, entitiesLabels, apioperation } from '../helpers/Constants';
import { api } from '../helpers/api/api';
import { RenderDataTableCell, NoRecordsPlaceholder, Pagination } from '../helpers/jsonschemaform/DataTableExtention';

export class HistoryTable extends Component {
    initState = (props) => {

        return {

            entityId: props.entityId,

        };
    }

    constructor(props) {
        super(props);
        this.state = {
            ...this.initState(props),
            itemList: [],
            isLoading: false,
        };
    }

    componentWillReceiveProps(nextProps) {
       
        if (nextProps.isOpenModal && !this.props.isOpenModal) {
            this.getHistoryWF(this.props.entityId);
        }
    }

    /*************API********************/
    getHistoryWF = (id) => {
        this.setState({ isLoading: true });
        api.get('/historyWF/', id==null?this.state.entityId: id)
            .then(response => {
                //console.log(response);
                this.setState({
                    itemList: response.data
                });
            }).catch(error => {
                showNotification.error(getError(error, entitiesLabels.HISTORYWF, apioperation.GET));

            }).finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    }
    /*********************************/

    render() {
        const modalHeader = {
            title: "History",
            iconDescription: 'Close',
            buttonOnClick: () => this.props.onClose()
        };
        const DTHeaders = [
            { key: 'eventDescription', header: 'Description' },
            { key: 'timeOfOccurance', header: 'Date', type: 'datetime' },
            { key: 'userMail', header: 'User' },
            ... (this.state.itemList != null && this.state.itemList.length > 0 && this.state.itemList.find(x => x.nextApproverMail != null)) ? [{ key: 'nextApproverMail', header: 'Approval - Consolidation in charge to' }] : [], //RITM0946152

        ];
        const DTRows = this.state.itemList || [];



        return (
            <ComposedModal
                className="light-modal modal--modal--container "
                open={this.props.isOpenModal}
                danger="false"
                onClose={() => this.props.onClose()}
            >
                <ModalHeader className="margin-modal" {...modalHeader} >
                </ModalHeader>
                <ModalBody className="margin-modal margin-modal-content  history-list-table" >

                    <div className="bx--grid">
                        <div className="bx--row">
                            <DataTable
                                rows={DTRows}
                                headers={DTHeaders}
                                useZebraStyles={true}
                                size="compact"
                                radio
                                render={({ rows, headers, getHeaderProps, getRowProps }) => (
                                    <TableContainer className="max-width" >
                                        {this.state.isLoading ?
                                            <DataTableSkeleton headers={[]} rowCount={3} zebra={false} compact={false} />
                                            :
                                            <Table className="" >
                                                <TableHead className="colorgray" >
                                                    <TableRow>

                                                        {headers.map(header => (
                                                            <TableHeader {...getHeaderProps({ header })} >
                                                                {header.header}
                                                            </TableHeader>
                                                        ))}

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        (rows == null || rows.length == 0)
                                                            ?
                                                            <NoRecordsPlaceholder labelText="No records" colSpan={headers.length + 1} />
                                                            :
                                                            rows.map(row => (
                                                                <TableRow {...getRowProps({ row })}  >

                                                                    {row.cells.map(cell =>
                                                                        <RenderDataTableCell key={cell.id} cell={cell} header={headers.find(x => x.key === cell.info.header)} />
                                                                    )}
                                                                </TableRow>
                                                            ))
                                                    }
                                                </TableBody>

                                            </Table>

                                        }
                                    </TableContainer>
                                )}
                            />
                        </div>


                    </div>

                </ModalBody>
                {/* <ModalFooter>
                    <Button kind="secondary" onClick={() => this.props.onCancel()}>Cancel</Button>
           
                </ModalFooter> */}
            </ComposedModal>
        );
    }
}

